export default function () {
    document.addEventListener('DOMContentLoaded', function () {
        let API_TRIGGER_GOAL = `${window.location.origin}/aha-service/analytics/TriggerGoal`;
        let API_TRACK_EVENT = `${window.location.origin}/aha-service/analytics/trackevent`;

        // D A T A  T R A C K I N G  A T T R I B U T E
        let trackingEls = document.querySelectorAll('[data-tracking]');
        // L O O P
        Array.prototype.forEach.call(trackingEls, el => {
            // CLICK HANDLER
            el.addEventListener('click', (e) => {
                if(e.currentTarget.getAttribute('data-tracking') === '') { return; }
                if(e.currentTarget.tagName === 'A') {
                    e.preventDefault();
                    var _link = e.currentTarget.getAttribute('href');
                    var _target = e.currentTarget.getAttribute('target');
                    // get current target that has class twoClick and set it to a variable to use later
                    var _twoClick = e.currentTarget.classList.contains('twoClick');
                    // get the link in the modal that has the text that says "proceed" and set it to a variable to use later
                    var _proceedLink = document.querySelector('.proceed');
                }
                let data = el.getAttribute('data-tracking');
                // Convert single quote to double quote, JSON format specific
                data = data.replace(/'/g, '"');
                const obj = JSON.parse(data);

                // Destructuring assignments
                const { goalId, ...pageEvent } = obj;
                let goalObj = { 'goalId': goalId };
                let trackEventObj = pageEvent;
                if(Object.keys(goalObj).length !== 0 && goalObj.constructor === Object) {
                    postData(API_TRIGGER_GOAL, goalObj);
                }

                if(Object.keys(trackEventObj).length !== 0 && trackEventObj.constructor === Object) {
                    postData(API_TRACK_EVENT, trackEventObj);
                }
                /* eslint-disable-next-line */
                // if the current target has class twoClick, then wait till proceed is clicked to open the link
                if(_twoClick) {
                    _proceedLink.addEventListener('click', function () {
                        if(_link !== '#') {
                            setTimeout(function () {
                                window.open(_link, _target);
                            }, 250);
                        }
                    });
                }
                // commenting out to stop opening new tab and letting the link work as normal
                if(e.currentTarget.tagName === 'A') {
                    if(e.currentTarget.getAttribute('href') !== '#') {
                        setTimeout(function () {
                            // if target is null, open in same window else open in _target
                            if(_target === null) {
                                window.location.href = _link;
                            } else {
                                window.open(_link, _target);
                            }
                        }, 250);
                    }
                }
            });
        });
        // E N D  L O O P

        // P O S T
        function postData(api, dataObj) {
            /* eslint-disable-next-line */
            fetch(api, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataObj)
            })
                .then(response => {
                    // if there is a response from the server
                    if(response) {
                        return response.json();
                    }
                })
                .then(result => {
                    if(result) {
                        // log response
                        // console.log('RESPONSE', result);
                    }
                })
                .catch(error => {
                    if(error.constructor === Object) {
                        /* eslint-disable-next-line */
                        console.error('ERROR:', error);
                    }
                })
                .finally(() => {
                    // console.log('Promise done');
                });
        }
    });
}



// WEBPACK FOOTER //
// ./src/app/utils/analytics-campaign-tracker.js